import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const collapseForm = async (id: number) => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(
        // @ts-ignore
        routable.getRoute('apiCommunicationCollapseItem'),
        {
            _itemId_: id,
        }
    );
    try {
        // @ts-ignore
        loader.show();
        const response = await $api.post(url);
        // @ts-ignore
        loader.hide();

        return response.data;
    } catch (error) {
        // @ts-ignore
        loader.hide();
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error.message;
    }
};
